export const SITE_NAME = 'GearsZone';
export const SITE_DOMAIN = 'gearszone.online';
export const SITE_URL = 'https://gearszone.online';
export const SITE_TAGLINE = 'Design software and digital marketing tools';
export const SUPPORT_EMAIL = 'hello@gearszone.online';
export const SUPPORT_PHONE = '+1 (888) 555-0142';
export const SUPPORT_PHONE_TEL = '+18885550142';

/** Legal operator (Nodex Global LLC) */
export const COMPANY_NAME = 'Nodex Global LLC';
export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';
export const ADDRESS = `${ADDRESS_LINE1} ${ADDRESS_LINE2}`;

export const LEGAL_UPDATED = '24 August 2026';

/** Full legal disclaimer for footer and policy pages */
export const FOOTER_DISCLAIMER = [
  `${SITE_NAME} (${SITE_DOMAIN}) is operated by ${COMPANY_NAME}, ${ADDRESS}. We sell design software and digital marketing tools online and provide related customer support. We are an independent retailer and are not affiliated with, endorsed by, or sponsored by any software publisher unless a product page clearly states otherwise.`,
  'Product names, logos, and trademarks mentioned anywhere on this website belong to their respective owners and are used for identification only. Their use does not imply endorsement or partnership.',
  'Prices may change without notice. Licence terms, seat counts, and features vary by plan. Please read our Terms of Service, Privacy Policy, Refund Policy, and Disclaimer before completing a purchase.',
];
